import { environment } from 'environments';

export const msalConfig = {
  auth: {
    clientId: environment.msalClientID,
    authority: `https://login.microsoftonline.com/${environment.msalTenantID}`,
    redirectUri: environment.baseUrl,
  },
  cache: {
    cacheLocation: 'localStorage',
    claimsBasedCachingEnabled: true,
  },
};

export const loginRequest = {
  scopes: [`api://${environment.msalResourceScopeID}/access_as_user`],
};
